'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Dictionary } from '@/src/lib/dictionary/types';
import SearchForm from '@/src/app/components/Search/SearchForm';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import dynamic from 'next/dynamic';
const Overlay = dynamic(() => import('@/src/app/components/Overlay/Overlay'), {
  ssr: false
});
type Props = {
  dict: Dictionary;
  lang: string;
  country: string;
};
export const SEARCH_OVERLAY_PARAM = 'open-search';
export function getOpenSearchParam(searchParams: ReadonlyURLSearchParams | null): string | undefined {
  const openSearchParam = searchParams?.get(SEARCH_OVERLAY_PARAM);
  return openSearchParam ?? undefined;
}
export default function SearchButton(t0) {
  const $ = _c(15);
  const {
    dict,
    lang,
    country
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = getOpenSearchParam(searchParams);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openSearchParam = t1;
  const [open, setOpen] = useState(openSearchParam !== undefined);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(true);
    t3 = <Icon name={IconName.SEARCH} className="text-2xl! text-white" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== dict.general.search) {
    t4 = <button data-testid="search-button" className="bg-black w-[50px] h-[50px] flex items-center justify-center" title={dict.general.search} onClick={t2}>{t3}</button>;
    $[4] = dict.general.search;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== country || $[7] !== dict || $[8] !== lang || $[9] !== open || $[10] !== openSearchParam) {
    t5 = open && <Overlay setOpen={setOpen} dict={dict} closeTitle={dict.search.close} lang={lang} country={country} testId="search-dialog"><SearchForm lang={lang} dict={dict} setOverlay={setOpen} searchQuery={openSearchParam} country={country} /></Overlay>;
    $[6] = country;
    $[7] = dict;
    $[8] = lang;
    $[9] = open;
    $[10] = openSearchParam;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}